export default __webpack_public_path__ + "static/media/theenigmataofyag.b89f663b.jpg";